import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { Tooltip } from '@material-ui/core';

import BrSplitDropdownMenu from '@components/BrSplitDropdownMenu';
import ColorStyles from '@components/ColorStyles';

export default function ClickableActionsColumn({ row, col, cell }) {
  const { variants, isEditable, isLive, groupBy } = row.Original_Data;
  const isReadOnly = !isEditable || isLive;
  const isGroupBy = !!groupBy;
  const isDeletable = !isReadOnly && variants === 1;
  const { tooltipText, isColumnDisabled } = cell;

  // Remove options like delete for rows which are either from parent site in case of multi-site OR live under testing.
  function filterByReadOnly(item) {
    if (item.value === 'delete_rule') {
      return item.showIfReadOnly || isDeletable;
    }
    if (item.showIfReadOnly) {
      return true;
    }
    return false;
  }

  let displayItems = Object.values(col.columnConfig.optionsList);
  if (isReadOnly) {
    displayItems = displayItems.filter(filterByReadOnly);
  }

  if (isGroupBy) {
    displayItems = displayItems.filter((item) => item.showIfGroupBy);
  }

  displayItems = displayItems.filter((item) => !item.disabled);

  let titleText = 'Manage';
  if (!isReadOnly && col.columnConfig.editableTitleText) {
    titleText = col.columnConfig.editableTitleText;
  } else if (isReadOnly && col.columnConfig.readOnlyTitleText) {
    titleText = col.columnConfig.readOnlyTitleText;
  }

  const handleOnSelectClick = (value) => {
    if (!isColumnDisabled) {
      col.columnConfig.onClick(row, value);
    }
  };

  const handleOnClick = () => {
    if (!isColumnDisabled) {
      col.columnConfig.onButtonClick(row);
    }
  };

  const brSplitDropdownMenuClassName = cn('clickable-action-button', {
    disabled: isColumnDisabled,
  });

  const brSplitDropDownWithoutHover = (
    <BrSplitDropdownMenu
      title={titleText}
      className={brSplitDropdownMenuClassName}
      useBtnStyle
      btnColorStyle={ColorStyles.BLUE}
      selected={{}}
      onSelect={handleOnSelectClick}
      onClick={handleOnClick}
      items={displayItems}
    />
  );

  const brSplitDropDownWithHover = (
    <Tooltip title={tooltipText} placement="top-start">
      <span className="inherit-all">{brSplitDropDownWithoutHover}</span>
    </Tooltip>
  );

  return (
    <div className="br-table-clickable-actions-column">
      {tooltipText ? brSplitDropDownWithHover : brSplitDropDownWithoutHover}
    </div>
  );
}

ClickableActionsColumn.propTypes = {
  row: PropTypes.shape({
    Original_Data: PropTypes.shape({
      id: PropTypes.any,
      name: PropTypes.any,
      type: PropTypes.any,
      isEditable: PropTypes.bool,
      groupBy: PropTypes.string,
    }).isRequired,
  }).isRequired,
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onButtonClick: PropTypes.func.isRequired,
      onClick: PropTypes.func.isRequired, // (row, value:type) :=> {}
      onDelete: PropTypes.func.isRequired,
      optionsList: PropTypes.any,
      editableTitleText: PropTypes.string,
      readOnlyTitleText: PropTypes.string,
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.any,
    isColumnDisabled: PropTypes.bool,
    tooltipText: PropTypes.string,
  }).isRequired,
};
